<h2 mat-dialog-title>Error</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onClose()">OK</button>
</mat-dialog-actions>
